import firebase from "firebase/app";

import { Card } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";

import { Organization } from "astrid-firestore/src/api/organizations/types/Organization";
import updateOrganization from "astrid-firestore/src/api/organizations/updateOrganization";

import PrimaryButton from "../../../ui/components/Buttons/PrimaryButton";

import useArticleTypeOptions from "../../../articles/hooks/useArticleTypeOptions";
import Form from "../../../forms/components/Form/Form";
import useSimpleForm from "../../../forms/hooks/useSimpleForm";

export default function DistributionSettingsOther({ organization }) {
	const { t } = useTranslation();

	const form = useSimpleForm({
		schema: Organization,
		defaultValues: {
			contractHolderName: organization.contractHolderName || "",
			automaticDistributionTypes: organization.automaticDistributionTypes || [],
		},
		onSubmit: async ({ contractHolderName, automaticDistributionTypes }) => {
			await updateOrganization(firebase, organization.ref, { contractHolderName, automaticDistributionTypes });
		},
	});

	const { formState, onSubmit } = form;

	const articleTypeOptions = useArticleTypeOptions();

	return (
		<Card fluid>
			<Card.Content>
				<Form form={form}>
					<Form.Input name="contractHolderName" label={t("contractHolderName", "Contract holder name")} />
					<Form.Select
						name="automaticDistributionTypes"
						label={t("automaticDistributionTypes", "Article types for automatic distribution")}
						options={articleTypeOptions}
						multiple
					/>
				</Form>
			</Card.Content>

			<Card.Content>
				<PrimaryButton
					disabled={formState.isSubmitting || !formState.isDirty}
					loading={formState.isSubmitting}
					onClick={onSubmit}
				>
					{t("save", "Save")}
				</PrimaryButton>
			</Card.Content>
		</Card>
	);
}
